import React from 'react';
import { Flex, Column, Spacer } from '@oliasoft-open-source/react-ui-library';
import { simulationChartType } from 'src/enums/compare-estimates';
import { withErrorBoundary } from '@oliasoft-open-source/react-ui-library';
import { Plot } from 'views/well-details/drawer/offset-wells/estimates-chart/plot';

const EstimatesChart = ({ estimates, currentEstimate }) => {
  const controlsPortalId = `combined-chart-controls-${simulationChartType.OPERATION_VS_DEPTH}`;

  return (
    <>
      <Column>
        <Flex alignItems="center" justifyContent="right">
          <div id={controlsPortalId} />
        </Flex>
        <Spacer />
        <Plot
          key={`${simulationChartType.OPERATION_VS_DEPTH}`}
          estimates={estimates}
          controlsPortalId={controlsPortalId}
          currentEstimate={currentEstimate}
        />
      </Column>
    </>
  );
};

export default withErrorBoundary(EstimatesChart);
